import React from "react";
import Utils from "../../utility";
import Calender from "./calender";
import PropTypes from "prop-types";

/**
 * Renders a date range selector component.
 *
 * @param {object} dates - An object containing the start and end dates.
 * @param {function} setDates - A function to update the start and end dates.
 * @return {JSX.Element} The date range selector component.
 */
const SelectDate = (
  {
    date,
    setDate,
    placeHolder,
    calenderOpen,
    setCalenderOpen,
    calendarDropDownRef,
    expiryDateErr,
    isEdit
  },
  isTop = true
) => {
  /**
   * Updates the dates based on the selected date and position.
   *
   * @param {Date} selectedDate - The selected date.
   * @param {string} position - The position ('start' or 'end').
   * @return {void}
   */
  const handleDateChange = (selectedDate) => {
    setDate(selectedDate?.toDate().setHours(23, 59, 59, 999));
    setCalenderOpen(false);
  };
  /**
   * Sets the calender open state.
   *
   * @return {void}
   */
  const setCalender = () => {
    setCalenderOpen(!calenderOpen);
  };

  return (
    <div ref={calendarDropDownRef} className="flex w-full flex-row gap-3">
      <div
        className={`relative flex h-10 w-full ${isEdit ? " pointer-events-none bg-grey-25" : "cursor-pointer"}  flex-row  items-center justify-between gap-2 rounded border ${expiryDateErr ? "border-red-10" : "border-grey-D9D9D9"} outline-none`}
      >
        <div className="flex w-full items-center" onClick={setCalender}>
          <input
            className="ml-13px w-full cursor-pointer font-MontserratMedium text-ft15-26.25 outline-none placeholder:text-grey-20"
            readOnly
            value={date && Utils.dateFormat(date)}
            placeholder={placeHolder}
          />
          <img className="mr-3" src="/images/calender.svg" alt="Calender" />
        </div>
        {calenderOpen && (
          <div
            className={
              isTop
                ? "absolute bottom-16 left-0 z-10 "
                : "absolute bottom-0 left-0 top-10 z-10 mt-9px"
            }
          >
            <div className="rounded border border-grey-D9D9D9 bg-white px-10 py-5 ">
              <Calender
                date={date}
                handleDateChange={handleDateChange}
                isSingleDate={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

SelectDate.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  setDate: PropTypes.func.isRequired,
  placeHolder: PropTypes.string,
  calenderOpen: PropTypes.bool.isRequired,
  setCalenderOpen: PropTypes.func.isRequired,
  calendarDropDownRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf() })
  ]),
  expiryDateErr: PropTypes.string,
  isEdit: PropTypes.bool
};

export default SelectDate;
